import { render, staticRenderFns } from "./DirectorDashboard.vue?vue&type=template&id=9b0322ac&scoped=true&lang=html&"
import script from "./DirectorDashboard.vue?vue&type=script&lang=js&"
export * from "./DirectorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DirectorDashboard.vue?vue&type=style&index=0&id=9b0322ac&prod&lang=css&"
import style1 from "./DirectorDashboard.vue?vue&type=style&index=1&id=9b0322ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0322ac",
  null
  
)

export default component.exports